import * as React from "react";

const Checkmark: React.FC = () => {
    return <svg width="12px" height="9px" viewBox="0 0 12 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-145.000000, -420.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(66.000000, 190.000000)">
                    <polygon points="4.1 6.1 1.4 3.4 0 4.9 4.1 9 11.7 1.4 10.3 0"></polygon>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(Checkmark);
